import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import { _win } from 'core/variables';
import CalcChart from './calcChart';

export default new RouteHandler({
    init() {
        const calcChart = new CalcChart();

        const deviceIsMobile = () => _win.innerWidth < 1001;

        const handleTouchOrMouse = (chart, slider) => {
            if (tracking) {
                if (! slider.isActive) {
                    slider.isActive = !slider.isActive;

                    if (slider.$input.hasClass('-active')) {
                        slider.$input.addClass('-inactive').removeClass('-active');
                    } else {
                        slider.$input.addClass('-active').removeClass('-inactive');
                    }

                    slider.$title.addClass('-active').removeClass('-inactive').attr('aria-pressed', 'true');
                }

                update(chart, slider);
            }
        }

        const update = (chart, slider) => {
            slider.updateSliderValue(slider.$element);
            slider.updateSliderLabel();
            $('.calculator-earnings_summary-amount').text(`${Math.round(chart.setTotal()).toLocaleString('en-US')}`);

            let $activeRanges = $('.calculator_range-slide.-active');
            
            if ($activeRanges.length) {
                let params = '?';

                $activeRanges.each((el, index) => {
                    const field = $(el)
                        .attr('aria-label')
                        .replace(' Value Range', '')
                        .replace('Value Range', '')
                        .replace(' ', '_');

                    const value = $(el).val();

                    index === $activeRanges.length - 1 
                        ? params = `${params}${field}=${value}` 
                        : params = `${params}${field}=${value}&` 
                });

                const calcBaseLink = `${_win.location.protocol}//${_win.location.hostname}/earnings-calculator`;
                $(':homePageEarningsLink').children().first().attr('href', `${calcBaseLink}${params}`);
            }

            chart.updateGraph(deviceIsMobile(), Number(chart.getPercent()));
        };

        let tracking = false;

        $events.on(window, 'resize', () => {
            calcChart.init();
            calcChart.updateGraph(deviceIsMobile, calcChart.getPercent());

            calcChart.sliders.forEach((slider) => {
                slider.updateSliderValue(slider.$element);
                slider.updateSliderLabel();
            });
        });

        calcChart.sliders.forEach((slider) => {
            $events.on(slider.$element, 'click', (e) => {
                if (! slider.activeByDefault
                    && ! $(e.target).hasClass('range calculator_range-slide')) {
                    slider.isActive = !slider.isActive;

                    if (slider.$input.hasClass('-active')) {
                        slider.$input.addClass('-inactive').removeClass('-active');
                    } else {
                        slider.$input.addClass('-active').removeClass('-inactive');
                    }

                    if (slider.$title.hasClass('-inactive')) {
                        slider.$title.addClass('-active').removeClass('-inactive').attr('aria-pressed', 'true');
                    } else {
                        slider.$title.addClass('-inactive').removeClass('-active').attr('aria-pressed', 'false');
                    }
                }
                
                update(calcChart, slider);
            });

            $events.on(slider.$input, 'change', (e) => {
                if (! slider.isActive) {
                    slider.isActive = !slider.isActive;

                    if (slider.$input.hasClass('-active')) {
                        slider.$input.addClass('-inactive').removeClass('-active');
                    } else {
                        slider.$input.addClass('-active').removeClass('-inactive');
                    }

                    slider.$title.addClass('-active').removeClass('-inactive').attr('aria-pressed', 'true');
                }

                update(calcChart, slider);
            });

            $events.on(slider.$input, 'mousemove', () => {
                handleTouchOrMouse(calcChart, slider);
            });

            $events.on(slider.$input, 'touchmove', () => {
                handleTouchOrMouse(calcChart, slider);
            });

            $events.on({
                '.calculator_range-slide': {
                    mousedown: () => {
                        tracking = true;
                    },
                    mouseup: () => {
                        tracking = false;
                    },
                    touchstart: () => {
                        tracking = true;
                    },
                    touchend: () => {
                        tracking = false;
                    },
                },
            });
        });
    },
});
